export default __webpack_public_path__ + "static/media/video-horizontal-background-0001.0b795a03.png";